import { render } from "./Cstats.vue?vue&type=template&id=1ca237cd"
import script from "./Cstats.vue?vue&type=script&lang=js"
export * from "./Cstats.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__